import {
  BUILDING_IMPACT_KINDS,
  resolveBuildingImpactKind,
  resolveBuildingImpactPalette,
} from '../configs/buildingConstructionAnimation';
import {CENTRAL_QUARTER_PREFIX} from '../constants/tokens';
import {selectQuarterZoneVisible} from '../redux/reducers/privateStateReducer/selectors';
import {
  checkIfQuarterToken,
  resolveNewQuarterZoneCells,
} from '../utils/gameState/construction/resolveNewQuarterZoneCells';
import {getPlayer0xColor} from '../utils/players/getPlayer0xColor';

/**
 * Что добавляется к падению жетона (см. configs/buildingConstructionAnimation): какой
 * удар у постройки, сам удар и прожигание ячеек, на которых из-за нового квартала
 * больше нельзя строить другие кварталы. Все это украшение: его сбой не должен
 * мешать постройке.
 */

/**
 * @param {Object} params
 * @param {string} [params.tokenType]
 * @param {string} [params.specialBuildingType]
 * @returns {{kind: string, palette: {accent: number, light: number}}}
 */
export const resolveBuildingImpact = ({tokenType, specialBuildingType}) => {
  const kind = resolveBuildingImpactKind(tokenType, specialBuildingType);
  const isCentral = kind === BUILDING_IMPACT_KINDS.CENTRAL;
  return {
    kind,
    palette: resolveBuildingImpactPalette(kind, {
      buildingType: specialBuildingType || tokenType,
      playerColor: isCentral ? getPlayer0xColor(tokenType.slice(tokenType.indexOf(CENTRAL_QUARTER_PREFIX) + CENTRAL_QUARTER_PREFIX.length)) : undefined,
    }),
  };
};

/** Удар о землю в момент приземления жетона */
export const showBuildingImpact = (hexGridRenderer, hexKey, impact) => {
  try {
    hexGridRenderer.showBuildingImpact?.(hexKey, impact);
  } catch (error) {
    console.warn('[BuildingImpact] не удалось показать удар постройки', error);
  }
};

const NO_BURN = {ignite: () => {}, release: () => {}};

/**
 * Занять новые ячейки зоны кварталов на время полета жетона: штриховка на них
 * появится вспышкой, когда он упадет.
 *
 * @param {Object} store
 * @param {Object} hexGridRenderer
 * @param {string} hexKey
 * @param {string} token — что строят: зону создают только кварталы
 * @param {function(Object): Object} buildStateBefore — состояние до этой постройки
 * @returns {{ignite: function(): void, release: function(): void}} ignite — жетон
 *   упал, release — постройку сняли, пока он летел
 */
export const holdQuarterZoneBurn = (store, hexGridRenderer, hexKey, token, buildStateBefore) => {
  if (!checkIfQuarterToken(token) || !hexGridRenderer?.holdQuarterZoneBurn || !hexGridRenderer.quarterZoneBurn) {
    return NO_BURN;
  }

  try {
    const state = store.getState();
    const cells = resolveNewQuarterZoneCells(buildStateBefore(state), state);
    const burn = cells.length > 0
      ? hexGridRenderer.holdQuarterZoneBurn(hexKey, cells, () => store.getState())
      : null;
    if (!burn) {
      return NO_BURN;
    }
    return {
      ignite: () => hexGridRenderer.quarterZoneBurn.ignite(burn, {
        isZoneVisible: selectQuarterZoneVisible(store.getState()),
      }),
      release: () => hexGridRenderer.quarterZoneBurn.release(burn),
    };
  } catch (error) {
    console.warn('[BuildingImpact] не удалось посчитать прожигание зоны', error);
    return NO_BURN;
  }
};
